<script lang="ts">
    import LegacyMeasurementsPage from '@Criteria/Hierarchies/Pages/LegacyMeasurementsPage'
    export default LegacyMeasurementsPage
</script>

<template>
    <div>
        
        <CriterionScaleEditor :viewModel="criterionScaleEditor"
                              @assign-custom-scale="handleAssignCustomScaleMeasurementCommand" />

        <DiscreteScaleEditor :viewModel="discreteScaleEditor" 
                             @create-scale="handleCreateWorkspaceScaleCommand" />

        <AttributeEditorDialog :viewModel="attributeEditorDialog"
                               @numeric-attribute-created="numericAttributeCreated" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId"/>

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <h3 v-if="!Initialized"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>
            <div v-if="Initialized">
                <a class="btn btn-outline-secondary float-right" href="https://www.transparentchoice.com/user-guide/build-criteria" title="User guide: Build criteria" target="_blank">
                    <i class="fa fa-info" aria-hidden="true"></i>
                </a>
                <h3>Goal: {{rm.GoalName}}</h3>
                <br />
                <GoalNavigation :WorkspaceId="workspaceId" :ProjectId="projectId" :EvalModelId="evalModelId" :ActivePage="'measurement'" :ScoringEnabled="rm.ScoringEnabled"></GoalNavigation>
                <nav class="navbar navbar-light navbar-expand-md bg-light" role="navigation">

                    <form class="form-inline mr-2">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="NoneCriteriaSelected" @click="selectAll"><i class="fa-regular fa-square"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="AnyCriteriaSelected && !AllCriteriaSelected" @click="unselectAll"><i class="fa-regular fa-square-minus"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="AllCriteriaSelected" @click="unselectAll"><i class="fa-regular fa-square-check"></i></button>

                            <button type="button" class="btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"></button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="selectAll">All</a>
                                <a class="dropdown-item" @click="unselectAll">None</a>
                                <a class="dropdown-item" @click="inverseSelection">Inverse</a>
                            </div>
                        </div>
                    </form>

                    <form class="form-inline mr-auto">
                        <div class="btn-group">
                            <button v-if="AnyCriteriaSelected" type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown">Set measurement</button>
                            <div class="dropdown-menu">
                                <h6 class="dropdown-header">Survey based</h6>
                                <div v-if="ScalesTemplates == null">
                                    <i class="fa fa-spinner fa-spin"></i> Loading scales
                                </div>
                                <div v-else>
                                    <small v-if="ScalesTemplates.length === 0" class="text-muted px-4 mb-1 font-italic d-block">You don't have any scales templates yet.</small>
                                    <a v-for="st in ScalesTemplates" :key="st.Id" class="dropdown-item" @click="handleBulkAssignScaleTemplateMeasurementCommandV1(st)">{{st.Name}}</a>
                                </div>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" @click="handleBulkAssignPairwiseMeasurementCommand">Pairwise comparisons</a>
                            </div>
                        </div>
                    </form>

                    <form class="form-inline my-2 my-lg-0" role="search">
                        <input v-model="SearchPhrase" class="form-control form-control-sm mr-sm-2" type="search" placeholder="Search">
                    </form>
                </nav>
                <br />
                <div class="card-deck">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Survey based  <small>(<a class="text-primary" @click="showWorkspaceScaleCreator(null)">create scale template</a>)</small></h5>
                            <p class="text-muted">Collect Data by asking respondents to rate alternatives - ideal for capturing experts' opinions & stakeholders' points of view.</p>

                            <div v-for="c in SurveyBased" :key="c.CriterionId" class="tile rounded-0 mx-0 mt-0 mb-3">
                                <p class="text-ellipsis fg-color-gray mb-0 mt-1">
                                    <input type="checkbox" v-model="c.IsSelected">
                                    <span v-bind:title="c.Name">{{c.Name}}</span>
                                </p>
                                <small class="text-muted">{{c.Path}}</small><br />

                                <p v-if="c.Loading" class="m-0"><i class="fa fa-spinner fa-spin"></i></p>

                                <div class="dropdown" v-if="!c.Loading">
                                    <a class="text-primary" data-toggle="dropdown">{{c.MeasurementLabel}}</a>
                                    <div class="dropdown-menu" style="max-height: 300px; overflow-y: auto;">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <h6 class="dropdown-header">Survey based</h6>
                                                    <div v-if="c.HasScale">
                                                        <a class="dropdown-item" @click="showCriterionScaleEditor(c)">Edit scale</a>
                                                        <a class="dropdown-item" @click="showWorkspaceScaleCreator(c)">Save as scale template</a>
                                                        <a class="dropdown-item" @click="handleAssignPairwiseMeasurementCommand(c)">Pairwise comparisons</a>
                                                        <div class="dropdown-divider"></div>
                                                    </div>

                                                    <a class="dropdown-item" v-if="!c.HasScale" @click="showCriterionScaleEditor(c)">Custom scale</a>

                                                    <small v-if="ScalesTemplates.length === 0" class="text-muted px-4 mb-1 font-italic d-block">
                                                        You don't have any scales templates yet.
                                                    </small>

                                                    <a v-for="st in ScalesTemplates" :key="st.DiscreteScaleId" class="dropdown-item" @click="handleAssignScaleTemplateMeasurementCommandV1(c, st)">
                                                        {{st.Name}}
                                                    </a>
                                                </div>
                                                <div class="col-md-6">
                                                    <h6 class="dropdown-header">Attribute based</h6>
                                                    <small class="text-muted px-4 mb-1 font-italic d-block" v-if="Attributes.length === 0">You don't have any attributes yet.</small>
                                                    <a v-for="attr in Attributes" :key="attr.Id" class="dropdown-item" @click="handleAssignAttributeMeasurementCommand(c, attr.Id)">
                                                        {{attr.Name}}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Attribute based <small>(<a class="text-primary" @click="showAttributeCreator">create attribute</a>)</small></h5>
                            <p class="text-muted">Collect Data via a Form - ideal for using the output from existing models, hard data, or a subjective rating from a single source.</p>

                            <div v-for="c in AttributeBased" :key="c.CriterionId" class="tile rounded-0 mx-0 mt-0 mb-3">
                                <p class="text-ellipsis fg-color-gray mb-0 mt-1">
                                    <input type="checkbox" v-model="c.IsSelected">
                                    <span v-bind:title="c.Name">{{c.Name}}</span>
                                </p>
                                <small class="text-muted">{{c.Path}}</small><br />

                                <p v-if="c.Loading" class="m-0"><i class="fa fa-spinner fa-spin"></i></p>

                                <div class="dropdown" v-if="!c.Loading">
                                    <a class="text-primary" data-toggle="dropdown">{{c.MeasurementLabel}}</a>
                                    <div class="dropdown-menu" style="max-height: 300px; overflow-y: auto;">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <h6 class="dropdown-header">Survey based</h6>
                                                    <a class="dropdown-item" @click="showCriterionScaleEditor(c)">Custom scale</a>
                                                    <small v-if="ScalesTemplates.length === 0" class="text-muted px-4 mb-1 font-italic d-block">
                                                        You don't have any scales templates yet.
                                                    </small>
                                                    <a v-for="st in ScalesTemplates" :key="st.DiscreteScaleId" class="dropdown-item" @click="handleAssignScaleTemplateMeasurementCommandV1(c, st)">
                                                        {{st.Name}}
                                                    </a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" @click="handleAssignPairwiseMeasurementCommand(c)">Pairwise comparisons</a>
                                                </div>
                                                <div class="col-md-6">
                                                    <h6 class="dropdown-header">Attribute based</h6>
                                                    <small class="text-muted px-4 mb-1 font-italic d-block" v-if="Attributes.length === 0">You don't have any attributes yet.</small>
                                                    <a v-for="attr in Attributes" :key="attr.Id" class="dropdown-item" @click="handleAssignAttributeMeasurementCommand(c, attr.Id)">
                                                        {{attr.Name}}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="alert alert-danger">
                                <p>
                                    NEGATIVE numbers will be rounded to zero in any calculations.
                                    Remember, you could use calculated attributes to transform your values so they are all positive.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
